import axios from "axios";
// 封装axios请求
export default (config, method = "POST") => {
  const service = axios.create({
    baseURL: "https://iot3.xingzhuo.xyz/api/bodydata", //正式环境
    // baseURL: "https://test.iot.xingzhuo.xyz/api/bodydata", //测试环境
    timeout: 15000,
    method,
  });
  service.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  service.interceptors.response.use(
    (res) => {
      if (res.status === 200) {
        return res.data;
      } else {
        return Promise.reject();
      }
    },
    (error) => {
      switch (error.response && error.response.status) {
        case 401:
          this.$message("token已经失效，请重新登陆！");
          setTimeout(() => {
            location.replace("#/404");
            localStorage.clear();
          }, 2000);
          return;
        case 405:
          this.$message("网络超时，请重新登陆！");
          setTimeout(() => {
            location.replace("#/404");
            localStorage.clear();
          }, 2000);
          return;
        case 500:
          this.$message("网络超时，请重新登陆！");
          return;
      }
      return Promise.reject(error);
    }
  );
  return service(config);
};
